import { ListItem, UnorderedList } from '@chakra-ui/react';
import { IConditionals } from 'types';
import Expression from '../Expression';

type ExpressionListProps = {
  pkey: string;
  values: IConditionals['expressions'];
  paramKey: string;
  onExpressionChange: () => void;
  deleteExpression: () => void;
  list: string[];
};
const ExpressionList = ({
  list,
  values,
  pkey,
  paramKey,
  onExpressionChange,
  deleteExpression,
}: ExpressionListProps) => {
  if (!Array.isArray(list) || !values) return null;

  const renderList = list.map((value: string, i) => (
    <ListItem
      sx={{
        listStyle: 'none',
      }}
      key={pkey}
    >
      <Expression
        pkey={pkey}
        item={values[value]}
        key={pkey}
        exKey={value}
        showOperator={i < list.length - 1}
        paramKey={paramKey}
        onExpressionChange={onExpressionChange}
        deleteExpression={deleteExpression}
      />
    </ListItem>
  ));

  return (
    <UnorderedList
      sx={{
        listStyle: 'none',
        w: 'full',
      }}
    >
      {renderList}
    </UnorderedList>
  );
};

export default ExpressionList;
